import type { EnhancedSmartLink } from './smartLinkTypes.ts';

export const DEFAULT_VISIBLE_LINK_COUNT = 3;

const isUnconnected = (link: EnhancedSmartLink): boolean => link.access === 'unauthorized';

/**
 * Flattens all page links into the top-N to show in the ungrouped byline menu.
 * Unconnected (unauthorized) links lead so the actionable "Connect" rows stay
 * visible; ties break by `occurrenceIndex` so the rest follow document order.
 */
export function getTopConnectionLinks(
	links: EnhancedSmartLink[],
	limit: number = DEFAULT_VISIBLE_LINK_COUNT,
): EnhancedSmartLink[] {
	return [...links]
		.sort((a, b) => {
			const rankDiff = Number(isUnconnected(b)) - Number(isUnconnected(a));
			return rankDiff !== 0 ? rankDiff : a.occurrenceIndex - b.occurrenceIndex;
		})
		.slice(0, limit);
}
